import { observable, makeAutoObservable } from 'mobx';
import { SelectValueType } from './ParticipantsInput';
import { RoleObjectType } from './ParticipantsInputGroup.state';

export class ParticipantsInputOutrightsState {
    @observable.ref value: Array<SelectValueType> = [];

    constructor() {
        makeAutoObservable(this);
    }

    changeByIdx(idx: number, participant: SelectValueType | null): Array<RoleObjectType> {
        console.info('ParticipantsInputGroupState:changeByIdx', { idx, participant });

        const value = [...this.value];

        if (participant === null) {
            value.splice(idx, 1);
        } else if (idx > value.length) {
            value.push(participant);
        } else {
            value[idx] = participant;
        }

        this.value = value;

        return value.map((item) => ({
            participant: item.id,
            name: item.label,
        }));
    }

    addNew(participant: SelectValueType | null): Array<RoleObjectType> {
        const value = [...this.value];

        if (participant === null) {
            console.error(
                'ParticipantsInputGroupState:changeByIdx -> it is not possible to delete a value for a non-added participant'
            );
        } else {
            value.push(participant);
        }

        this.value = value;

        return value.map((item) => ({
            participant: item.id,
            name: item.label,
        }));
    }
}
